<template>
  <div class="h-full">
    <div class="container mx-auto flex justify-center items-center h-full">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AuthLayout',
  };
</script>
